<template>
  <div>

    <el-dialog
        title="上传图集"
        :visible.sync="dialog"
        :before-close="noDialog"
        width="30%"
        center>
      <el-form :model="resourceCollections" label-width="150px" ref="ResourceProportionForm">
        <el-form-item label="宽度占比(%)" prop="width"
                      :rules="[
                          { required: true, message: '不能为空'},
                          { validator: notLeNum0, trigger: 'blur' },
                          ]">
          <el-input v-model="resourceCollections.width" type="number"></el-input>
        </el-form-item>
        <el-form-item label="高度类型" prop="heightType">
          <el-select v-model="resourceCollections.heightType">
            <el-option
                v-for="item in heightTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="resourceCollections.heightType==='1'" label="与宽度百分比(%)" prop="height"
                      :rules="[
                          { required: true, message: '不能为空'},
                          { validator: notLeNum0, trigger: 'blur' },
                          ]">
          <el-input v-model="resourceCollections.height" type="number"></el-input>
        </el-form-item>
        <el-form-item label="圆角(%)" prop="borderRadius"
                      :rules="[
                          { required: true, message: '不能为空'},
                          { validator: notLtNum0, trigger: 'blur' },
                          ]">
          <el-input v-model="resourceCollections.borderRadius" type="number"></el-input>
        </el-form-item>
        <el-form-item label="数量颜色" prop="numberColor">
          <el-color-picker v-model="resourceCollections.numberColor"></el-color-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" icon="el-icon-check" @click="insertResource('ResourceProportionForm')">插入文章</el-button>
      </span>

      <div class="avatar-uploader">
        <el-upload
            :action="fileBaseUrl"
            :show-file-list="false"
            :data="uploadImageData"
            :before-upload="beforeUploadImage"
            :on-success="afterUploadImage"
            multiple
            accept="image/*"
        >
          <i class="el-icon-picture avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="avatar-uploader">
        <el-upload
            :action="fileBaseUrl"
            :show-file-list="false"
            :data="uploadVideoData"
            :before-upload="beforeUploadVideo"
            :on-success="afterUploadVideo"
            multiple
            accept="video/*"
        >
          <i class="el-icon-video-camera avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div v-for="(e,i) in resourceCollections.resources" :key="i">
        <span v-if="e.type==='image'">
          <img :src="e.src" width="100px" height="100px">
        </span>
        <span v-else>
          <video :src="e.src" width="100px" height="150px"></video>
        </span>
        <el-button v-if="i!==0" type="info" size="mini" icon="el-icon-top" circle
                   @click="moveResource(i, true)"></el-button>
        <el-button v-if="i!==resourceCollections.resources.length-1" type="info" size="mini" icon="el-icon-bottom" circle
                   @click="moveResource(i, false)"></el-button>
        <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="doDelCardResource(i)"></el-button>
      </div>

    </el-dialog>

  </div>
</template>
<script>


import dialogMixin from "@/mixin/dialogMixin";
import {notLeNum0, notLtNum0} from "@/utils/check";
import getAliyunOssSign from "@/api/common/getAliyunOssSign";
import adminGetFileSignUrl from "@/api/common/adminGetFileSignUrl";
import {Message} from "element-ui";

export default {
  name: "DialogUploadResourceCollections",
  mixins:[dialogMixin],
  props: {
    resourceCollections: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      fileBaseUrl: process.env.VUE_APP_FILE_BASE_URL,
      uploadImageData:{},
      uploadVideoData:{},
      heightTypes:[
        {
          value:'0',
          label:'原比例'
        },
        {
          value:'1',
          label:'与宽度百分比'
        },
      ],
    }
  },
  methods:{
    notLtNum0,
    notLeNum0,

    async beforeUploadImage(file){
      await getAliyunOssSign("/common/sign").then(response => {
        //设置相关的参数
        let resultObj = response.data;
        this.uploadImageData = resultObj;
        this.uploadImageData.ossaccessKeyId = resultObj.accessid;
        //上传的文件名，使用UUID处理一下
        this.uploadImageData.key = resultObj.dir + '/' + file.uid + '_${filename}';
      });
      return true
    },
    afterUploadImage(response, file){
      //上传的完整的文件地址
      let filepath = 'upload/temp/' + file.uid + '_' + file.name;
      adminGetFileSignUrl(filepath).then(res=>{
        this.resourceCollections.resources.push({type: 'image', src: res.data})
      })
    },
    async beforeUploadVideo(file){
      await getAliyunOssSign("/common/sign").then(response => {
        //设置相关的参数
        let resultObj = response.data;
        this.uploadVideoData = resultObj;
        this.uploadVideoData.ossaccessKeyId = resultObj.accessid;
        //上传的文件名，使用UUID处理一下
        this.uploadVideoData.key = resultObj.dir + '/' + file.uid + '_${filename}';
      });
      return true
    },
    afterUploadVideo(response, file){
      //上传的完整的文件地址
      let filepath = 'upload/temp/' + file.uid + '_' + file.name;
      adminGetFileSignUrl(filepath).then(res=>{
        this.resourceCollections.resources.push({type: 'video', src: res.data})
      })
    },
    moveResource(i, isUp) {
      const newArr = JSON.parse(JSON.stringify(this.resourceCollections.resources))
      const box = newArr[i]
      if (isUp) {
        newArr[i] = newArr[i - 1]
        newArr[i - 1] = box
      } else {
        newArr[i] = newArr[i + 1]
        newArr[i + 1] = box
      }
      this.resourceCollections.resources = newArr
    },
    doDelCardResource(delCardResourceIndex) {
      const newArr = []
      for (let i = 0; i < this.resourceCollections.resources.length; i++) {
        if (i === delCardResourceIndex) continue
        newArr.push(this.resourceCollections.resources[i])
      }
      this.resourceCollections.resources = newArr
    },
    insertResource(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.resourceCollections.resources.length === 0) {
            return Message({message: '请至少上传一张图片或视频', type: "error", duration: 3000})
          }
          this.$emit('insert-resource', JSON.parse(JSON.stringify(this.resourceCollections)));
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },


  }
}
</script>
<style lang="scss" scoped>

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 60px;
  display: inline-block;

  .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 60px;
    display: block;
  }
}

</style>